module.exports = __webpack_public_path__ + "img/bg-pattern.7f8f2ddf.png";